<template>
	<div class="teaming-layout page-layout">
		<header :class="headerClasses">
			<slot name="header"></slot>
		</header>
		<main :class="bodyClasses">
			<slot name="body"></slot>
		</main>
		<footer class="page-layout__footer" v-if="$slots.footer">
			<slot name="footer"></slot>
		</footer>
		<slot name="prompts"></slot>
	</div>
</template>

<script>
/**
 * PageLayout
 *
 * Use within position:relative or position:absolute containers.
 *
 * Layout with header and main slots. By default, body is scrollable, but scrolling
 * can be disabled if children will handle scrolling.
 */
export default {
	name: "PageLayout",
	props: {
		scrollBody: {
			type: Boolean,
			default: true,
		},
		headerClass: {
			type: String,
			default: "",
		},
		bodyClass: {
			type: String,
			default: "",
		},
	},
	computed: {
		headerClasses() {
			const headerClass = this.headerClass.trim();
			return {
				"page-layout__header": true,
				[ headerClass ]: !!headerClass,
			};
		},
		bodyClasses() {
			const bodyClass = this.bodyClass.trim();
			return {
				"page-layout__body": true,
				"page-layout__body--scrollable": this.scrollBody,
				[ bodyClass ]: !!bodyClass,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.page-layout {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
}

.page-layout__header {
	// no size limitation on the header
}

.page-layout__body {
	// expand to fill the remaining space
	flex: 1;

	// if the body is NOT scrollable, the assumption is
	// that a scrollable child element will "dock" itself
	// within the body to control scrolling content
	overflow: hidden;
	position: relative;
}

.page-layout__body--scrollable {
	@include auto-y-scroll();
}

.page-layout__footer {
	// give any potential top border of a child component
	// breathing room so it doesn't get clipped
	padding-top: 0.0625rem;
}
</style>
